import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PubSub from 'pubsub-js'

import seo from '../services/seo';
import log from '../services/log';
import auth from '../services/auth';
import GA from '../services/ga';

import '../css/coin-chip.css';

function CoinChip(props){

  return (
    props.coin ? 
    <>
      <div className="topic-chip-container" onClick={() => {

      }}>
        <Link className="no-link" to={`/relative-strength-index/${seo.toSlug(props.coin.coin)}`} onClick={() => props.onClick(props.coin.coin)}>
          <div className="topic-chip hovered">
              <div className="inline-flex items-center justify-center gap-2">
                <img className="topic-logo1" title={`${props.coin.coin} RSI Live, Price, Moves, Charts, History, Alerts And Notifications`} alt={`${props.coin.coin} RSI Live, Price, Moves, Charts, History, Alerts And Notifications`} src={props.coin.image}/>
                <span className="whitespace-nowrap"><b>{props.coin.coin}</b></span>
              </div>
          </div>
        </Link>
      </div>
    </>
    :
    null
  );
};

CoinChip.defaultProps = {

}

export default CoinChip;
